import { connect } from 'react-redux'
import { Toolbar } from './Toolbar.jsx'
import { isItemDisplayable } from '../../../redux/availableActions/selectors'
import { isItemDisabled } from '../../../redux/availableActions/selectors'

const mapStateToProps = (state, ownProps) => ({
    items: ownProps.itemsSupplier(state),
    isItemDisplayable: (item) => isItemDisplayable(state, item),
    isItemDisabled: (item) => isItemDisabled(state, ownProps.name, item),
})

export const ToolbarContainer = connect(
    mapStateToProps,
)(Toolbar)
